import AdminLayout from "../layout/admin-layout/adminLayout";
import Dashboard from "../component/dashboard/Dashboard";
import Profile from "../component/profile/Profile";
import Changepassword from "../component/profile/Profile-changepassword";
import Customer from "../component/customer/Customer";
import AddNew from "../component/customer/Customer-addnew";
import FAQ from "../component/FAQ/FAQ";
import Contact from "../component/contact/Contact";
import User from "../component/users/User";
import UsersLayout from "../layout/users-layout/usersLayout";
import OrderList from "../component/orderlist/OrderList";
import Store from "../component/store/Store.jsx";
import StoreAddNew from "../component/store/Store-addnew.jsx";

import ProductList from "../component/products/ProductList";
import POS from "../component/pos/POS";
import FreeProductOffers from "../component/free-product-offers/FreeProductOffers";
import Configuration from "../component/configuration/Configuration";

const adminRoutesConfig = {
  path: "/admin",
  element: <AdminLayout />,
  children: [
    {
      path: "dashboard",
      element: <Dashboard />,
    },
    {
      path: "customer",
      element: <Customer />,
      children: [
        {
          path: "entry",
          element: <AddNew />,
        },
      ],
    },
    {
      path: "orderList",
      element: <OrderList />,
    },
    {
      path: "products",
      element: <ProductList />,
    },
    {
      path: "pos",
      element: <POS />,
    },
    {
      path: "free-product-offers",
      element: <FreeProductOffers />,
    },
    {
      path: "configuration",
      element: <Configuration />,
    },
    {
      path: "user",
      element: <User />,
    },
    {
      path: "FAQ",
      element: <FAQ />,
    },
    {
      path: "contact",
      element: <Contact />,
    },
    {
      path: "profile",
      element: <Profile />,
      children: [
        {
          path: "changepassword",
          element: <Changepassword />,
        },
      ],
    },
    {
      path: "users",
      element: <UsersLayout />,
    },
    {
      path: "stores",
      element: <Store />,
      children: [
        {
          path: "entry",
          element: <StoreAddNew />,
        },
      ],
    },
  ],
};

export default adminRoutesConfig;